import { render, staticRenderFns } from "./StudentEducation.vue?vue&type=template&id=4e84dde0&scoped=true"
import script from "./StudentEducation.vue?vue&type=script&lang=js"
export * from "./StudentEducation.vue?vue&type=script&lang=js"
import style0 from "./StudentEducation.vue?vue&type=style&index=0&id=4e84dde0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e84dde0",
  null
  
)

export default component.exports